import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { SearchInput, StatusFilter, Table, MobileTable, TableAction, StatusHandler, ArrayChecker, SubmissionStatus } from '../../../components'
import service from '../../../features/resource/service'
import { fetchResources } from '../../../features/organization/resources/slice'
import { SystemProvider } from '../../../features/system/provider'

function matchResourceToTable(resources, language){
  let result = []

  if(resources && resources.length > 0){
    for (let index = 0; index < resources.length; index++) {
      const resource = resources[index];
      const {id, title, type, category, submission} = resource

      result.push({
        id,
        title: title?.[language.name],
        type,
        category: category?.[language.name],
        visibility: '',
        submission
      })
    }
  }

  return result
}

const MainContent = () => {
  const dispatch = useDispatch()
  const [selectedRows, setSelectedRows] = useState([])
  const [requesting, setRequesting] = useState(false)
  const status = useSelector(state => state.organizationResources.status)
  const error = useSelector(state => state.organizationResources.error)
  const resources = useSelector(state => state.organizationResources.data)
  const language = useSelector(state => state.system.language)
  // const options = {limit: '3'}
  const options = {}

  const tableData = useMemo(() => matchResourceToTable(resources, language), [resources, language])
  const tableColumns = useMemo(
    () => [
      {
        Header: 'Title',
        accessor: 'title',
        // Cell: (props) => {
        //   const id = props.data[props.row.index].id
        //   return (
        //     <Link to={`/dashboard/resources/edit/${id}`}>
        //       {props.value}
        //     </Link>
        //   )
        // }
      },
      // {
      //   Header: 'Type',
      //   accessor: 'type',
      // },
      {
        Header: 'Category',
        accessor: 'category',
      },
      // {
      //   Header: 'Visibility',
      //   accessor: 'visibility',
      // },
      {
        Header: 'Submission',
        accessor: 'submission',
        Cell: ({ value }) => <SubmissionStatus value={value}/>
      },
      {
        Header: 'Action',
        accessor: 'id',
        Cell: (props) => {
          return (
            <div className="flex flex-col space-y-2">
              <Link to={`/resource/${props.value}/detail`} className="link">View</Link>
              <Link to={`/dashboard/resources/edit/${props.value}`} className="link">Edit</Link>
            </div>
          )
        },
      }
    ],
    []
  )

  // useEffect(() => {
  //   if(status === 'idle'){
  //     dispatch(fetchResources(options))
  //   }
  // }, [dispatch, status, options])

  useEffect(() => {
    dispatch(fetchResources(options))
    // eslint-disable-next-line
  }, [])

  const handleCheckbox = (rows) => setSelectedRows(rows)

  const handleBulkAction = (form) => {
    if(form.action === 'delete' && selectedRows.length > 0){
      let c = window.confirm("Apakah anda yakin akan menghapus data?")
      if(c){
        setRequesting(true)
        let count = 0

        const handleRequestDone = () => {
          count++
          if(count === selectedRows.length){
            setRequesting(false)

            // trigger re-fetch resources
            dispatch(fetchResources(options))
          }
        }

        for (let index = 0; index < selectedRows.length; index++) {
          const row = selectedRows[index];
          const id = row.original.id
          console.log('delete resource with this id: ', id)

          service.delete(id)
          .then(res => console.log(res))
          .catch(err => console.log(err))
          .then(() => {
            console.log(id, ' deleted.')
            handleRequestDone()
          })
        }
      }
    }
  }

  return <>
    <ArrayChecker data={tableData}>
      <StatusHandler
        status={status}
        error={error}
        onRetry={() => dispatch(fetchResources())}
      >
        <div style={{maxWidth: '370px'}} className="mb-5 lg:mb-8">
          <SearchInput />
        </div>

        <div className="mb-5 lg:mb-8">
          <StatusFilter />
        </div>

        <div className="mb-8">
          <TableAction
            onSubmit={handleBulkAction}
            requesting={requesting}
          />
        </div>

        <hr className="mb-8 lg:mb-4" />

        <SystemProvider>
          {/* Desktop Table */}
          <div className="hidden lg:block mb-12">
            <Table
              data={tableData}
              columns={tableColumns}
              withCheckbox
              handleCheckbox={handleCheckbox}
            />
          </div>

          {/* Mobile Table */}
          <div className="lg:hidden mobile-fullwidth mb-12">
            <MobileTable
              data={tableData}
              columns={tableColumns}
              withCheckbox
            />
          </div>
        </SystemProvider>
      </StatusHandler>
    </ArrayChecker>
  </>
}

export { MainContent }
